import { WarpEntity } from '@ripple/models';
import { EntityTypes } from './entity-types';

export class Community extends WarpEntity {
    id: string | number;

    constructor(obj) {
        super(obj);
        this.entityTypeId = EntityTypes.Community;
    }

    static empty(): Community {
        return new Community(super.emptyEntity(EntityTypes.Community));
    }

}